import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "signature-form-data signature-form-datetime-signed" }

import { SignatureDocumentFieldType } from '@/store/enums';
import { DateTime } from 'luxon';
import {onMounted, Ref, ref, computed} from 'vue';
import {usePortalIntakeStore} from "@/store/PortalIntakeModule";
import {useRootStore} from "@/store";


export default /*@__PURE__*/_defineComponent({
  __name: 'DateTimeSigned.vue3',
  props: {
    documentIndex: {},
    fieldIndex: {}
  },
  setup(__props: any) {

const props = __props;

const rootStore = useRootStore();
const facilityTimeZone = computed(() => rootStore.state.facility?.ianaTimeZoneName || 'system');

const value = ref(DateTime.now().setZone(facilityTimeZone.value).toLocaleString(DateTime.DATETIME_SHORT));

const intakeStore = usePortalIntakeStore();
const setDocumentField = (docIndex: number, fieldIndex: number, field: {type: SignatureDocumentFieldType, value: Ref<string|undefined>}) => 
    intakeStore.dispatch('setDocumentField', {docIndex, fieldIndex, field});

onMounted(() =>
    setDocumentField(props.documentIndex, props.fieldIndex, {type: SignatureDocumentFieldType.DateTime, value})
);

return (_ctx: any,_cache: any) => {
  const _component_p_input_text = _resolveComponent("p-input-text")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_p_input_text, {
      size: "small",
      readonly: "",
      disabled: "",
      class: "datetime-input",
      val: value.value,
      value: value.value
    }, null, 8, ["val", "value"]),
    _createElementVNode("span", _hoisted_1, _toDisplayString(value.value), 1)
  ]))
}
}

})